export enum EoriCollectionModalType {
  PRE_CHECKOUT = "PRE_CHECKOUT",
  CHECKOUT_INTERNATIONAL_ONLY = "CHECKOUT_INTERNATIONAL_ONLY",
  CHECKOUT_MIX = "CHECKOUT_MIX",
}

export enum EoriCollectionModalEntryPoint {
  CART = "CART",
  PLACE_ORDER = "PLACE_ORDER",
}
